import { Component } from '@angular/core';

@Component({
  selector: 'app-edit-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './edit-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class EditIconComponent {}
